import { StylovyzeDialogProps } from '../StylovyzeDialog/StylovyzeDialog';

/**
 * Props for WarningDialog component
 * Inherits all props from StylovyzeDialog with warning-specific styling applied.
 * The confirm button is automatically styled with error color to indicate warning state.
 */
export type WarningDialogProps = StylovyzeDialogProps;
